<template>
  <b-card no-body class="mb-4 overflow-hidden" style="min-width: 400px;">
    <b-row no-gutters>
      <b-col md="4" class="p-4 course-card">
        <h3>{{course.title}}</h3>
        <p>{{course.startDateTime | formatDate('MMMM D, YYYY')}}</p>
        <b-alert v-model="isInstructor" variant="primary">Instructor</b-alert>
      </b-col>
      <b-col md="8" class="p-4 text-right">
        <b-row>
          <b-col order-lg="1" order="3">
            <b-card-group column>
              <b-card class="text-center" border-variant="light" v-if="!isCompleted">
                <p class="text-muted"><strong>STARTS ({{course.startDateTime | fromNow}})</strong></p>
                <p class="text-primary"><strong>{{course.startDateTime | formatDate('dddd MMMM Do h:mm a')}} ({{timeZone}})</strong></p>
              </b-card>
              <b-card class="text-center" border-variant="light" v-if="!isCompleted">
                <p class="text-muted"><strong>ENDS</strong></p>
                <p class="text-primary"><strong>{{course.endDateTime | formatDate('dddd MMMM Do h:mm a')}} ({{timeZone}})</strong></p>
              </b-card>
              <b-card class="text-center" border-variant="light" v-if="isCompleted">
                <p class="text-muted"><strong>COMPLETED</strong></p>
                <p class="text-info"><strong>{{course.endDateTime | fromNow}}</strong></p>
              </b-card>
            </b-card-group>
            <b-progress :value="completed" :max="hours" variant="primary" v-if="!isCompleted && inProgress" class="mt-3"></b-progress>
          </b-col>
          <b-col order-lg="3" order="1" cols="12" lg="auto">
            <b-button :to="{ name: 'CourseDetails', params: { id : course.id }}" variant="primary" v-if="inProgress && !isCompleted" size="lg" class="mb-2">Resume</b-button>
            <b-button :to="{ name: 'CourseDetails', params: { id : course.id }}" variant="outline-primary" v-if="!inProgress" size="lg" class="mb-2">View</b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'

Vue.filter('formatDate', (value, format) => {
  if (!value) {
    return ''
  }
  return moment(value).format(format)
})

Vue.filter('fromNow', (value) => {
  if (!value) {
    return ''
  }
  return moment(value).fromNow()
})

export default {
  props: [ 'course', 'type' ],
  computed: {
    timeZone () {
      return moment.tz(moment.tz.guess()).format('z')
    },
    inProgress () {
      return moment(this.course.startDateTime) <= new Date() && moment(this.course.endDateTime) > new Date()
    },
    hours () {
      return moment(this.course.endDateTime).diff(moment(this.course.startDateTime), 'hours')
    },
    completed () {
      return moment().diff(moment(this.course.startDateTime), 'hours')
    },
    isCompleted () {
      return moment(this.course.endDateTime) < moment()
    },
    isInstructor () {
      return this.type === 'Instructor'
    }
  }
}
</script>

<style>

</style>
